import { AxiosRequestConfig } from 'axios';
import { restClient, restClientCaptcha } from '../rest-client';
import {
  IConfirmPhoneNumberData,
  IConfirmPhoneNumberResponse,
  ILoginData,
  IRegisterPhoneNumberData,
  ITokenData,
  IRegisterEmailData,
  IRefreshTokenFailedData,
} from './oauth.models';
import { OAuthRequestUrls } from './oauth.request-urls';
import { CaptchaType } from '../../graphql/configuration';

export const oauthApi = {
  login(data: ILoginData) {
    return restClient.post<ITokenData>(OAuthRequestUrls.login, {
      ...data,
      grant_type: 'password',
    });
  },
  registerPhoneNumber(data: IRegisterPhoneNumberData) {
    return restClient.post<ITokenData>(OAuthRequestUrls.registerMobile, data);
  },
  registerPhoneNumberCaptcha(data: IRegisterPhoneNumberData, token: string, captchaType?: CaptchaType) {
    return restClientCaptcha(token, captchaType).post<ITokenData>(OAuthRequestUrls.registerMobile, data);
  },
  confirmPhoneNumber(data: IConfirmPhoneNumberData, config: AxiosRequestConfig) {
    return restClient.post<IConfirmPhoneNumberResponse>(
      OAuthRequestUrls.confirmMobile, data, config,
    );
  },
  refreshToken(data: ITokenData | null) {
    return restClient.post<ITokenData | IRefreshTokenFailedData>(OAuthRequestUrls.refresh, {
      ...data,
      grant_type: 'refresh_token',
    });
  },
  registerEmail(data: IRegisterEmailData, config: AxiosRequestConfig) {
    return restClient.post<ITokenData>(OAuthRequestUrls.registerEmail, data, config);
  },
};
